import { PropsWithChildren } from 'react'
import { RadialBackground } from '@/ui/RadialBackground'
import LogoIcon from './logo.svg'
import styles from './UnauthorizedLayout.module.scss'

export const UnauthorizedLayout = ({ children }: PropsWithChildren) => {
    return (
        <RadialBackground variant={'welcome'}>
            <main className={styles.container}>
                <div className={styles.info}>
                    <section>
                        <div className={styles.iconContainer}>
                            <LogoIcon />
                        </div>
                        <h1 className={styles.title}>Controller Log</h1>
                    </section>
                </div>

                <div className={styles.card}>{children}</div>
            </main>
        </RadialBackground>
    )
}
